import React from "react";
import { motion } from "framer-motion";

// Wraps an image (or any visual) and plays a "curtain" reveal when it enters
// the viewport — a black panel overlayed on the content scales away to nothing.
// Children are rendered below the curtain so hover effects on the image still work.
export default function RevealImage({
  children,
  aspect = "aspect-[4/5]",
  className = "",
  delay = 0,
  direction = "up",
  once = true,
}) {
  const origin = {
    up: "origin-bottom",
    down: "origin-top",
    left: "origin-right",
    right: "origin-left",
  }[direction];
  const initial =
    direction === "up" || direction === "down" ? { scaleY: 1 } : { scaleX: 1 };
  const animate =
    direction === "up" || direction === "down" ? { scaleY: 0 } : { scaleX: 0 };

  return (
    <div className={`relative overflow-hidden ${aspect} bg-mist ${className}`}>
      {children}
      <motion.div
        aria-hidden
        className={`absolute inset-0 bg-paper z-10 pointer-events-none ${origin}`}
        initial={initial}
        whileInView={animate}
        viewport={{ once, margin: "-80px" }}
        transition={{ duration: 1.1, delay, ease: [0.76, 0, 0.24, 1] }}
      />
    </div>
  );
}
